import { registerLocale } from "react-datepicker";
import { useIntl } from "react-intl";
import { Navigate, Route, Routes } from "react-router-dom";
import { getDateLocale } from "../utils/DateLocale";
// import { HomeWrapper } from "../pages/home/HomeWrapper";
import { MasterLayout } from "../modules/common/components/MasterLayout";
import { FishingWrapper } from "../pages/fishing/FishingWrapper";
import { LiveCasinoWrapper } from "../pages/liveCasino/LiveCasinoWrapper";
import { SettingWrapper } from "../pages/setting/SettingWrapper";
import { SlotWrapper } from "../pages/slot/SlotWrapper";
// import { PromotionWrapper } from "../pages/promotion/PromotionWrapper";
import { PromotionListing } from "../modules/promotion/component/PromotionListing";
import { ReportListing } from "../modules/report/component/ReportListing";
import { AppGamesWrapper } from "../pages/appGames/AppGamesWrapper";
import { DashboardWrapper } from "../pages/dashboard/DashboardWrapper";
import { GamePlayWrapper } from "../pages/gamePlay/GamePlayWrapper";
import { HomeWrapper } from "../pages/home/HomeWrapper";
import { LotteryWrapper } from "../pages/lottery/LotteryWrapper";
import { SportWrapper } from "../pages/sport/SportWraper";

const PrivateRoutes = () => {
  const intl = useIntl();
  let locale = intl.locale;
  registerLocale(locale, getDateLocale(locale));

  return (
      <Routes>
        <Route element={<MasterLayout />}>
          <Route path="dashboard/*" element={<DashboardWrapper />} />
          <Route path="home/*" element={<HomeWrapper />} />
          <Route path="slot/*" element={<SlotWrapper />} />
          <Route path="live/*" element={<LiveCasinoWrapper />} />
          <Route path="fishing/*" element={<FishingWrapper />} />
          <Route path="app/*" element={<AppGamesWrapper />} />
          <Route path="gamePlay/*" element={<GamePlayWrapper />} />
          <Route path="setting/*" element={<SettingWrapper />} />
          <Route path="sport/*" element={<SportWrapper />} />
          <Route path="lottery/*" element={<LotteryWrapper />} />
          <Route path="/promotion" element={<PromotionListing />} />
          <Route path="/report" element={<ReportListing />} />
          <Route
            path="*"
            element={
              <Navigate
                to={
                  localStorage.getItem("isHomeIndex") === "true"
                    ? "/home"
                    : "/dashboard"
                }
              />
            }
          />
        </Route>
      </Routes>
  );
};

export { PrivateRoutes };

